import React, {useState,useEffect} from "react";
import { Row, Col,Button } from "react-bootstrap";
import { getTransactionByBusiness, getTransfer, getVersementByBusiness } from "../services/developerApi";
import filter from "../../../../assets/images/cuida_filter-outline.png";
import '../utils/detail.css';
import DetailVersementModal from "./detailVersement";
import FiltrerVersementModal from "./FiltrerVersementModal";
import TableContainerMin from "../../../../common/TableContainerMin";
import { Spin } from "antd";
import { Card, CardBody } from "reactstrap";
import { DownloadOutlined } from "@ant-design/icons";
import ExportTransaction from "./ExportTransaction";


const Versement = ({  developer}) => {
  const [loading, setLoading] = useState(false);
    const [modalState, setModalState] = useState({ type: null, data: null });
     const openModal = (type, data = null) => {
    setModalState((prevState) => (prevState.type === type ? { type: null, data: null } : { type, data }));
  };
   const [filterValues, setFilterValues] = useState(null);
    const [transferBusiness, setBusinessTransfer] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
   const filteredVersement = transferBusiness?.filter((versement) => {
    let match = true;
    if (searchTerm) {
      match = match && String(versement?.amount).includes(searchTerm);
    }
    if (filterValues?.status) {
      match = match && versement.status === filterValues.status;
    }
    if (filterValues?.createdAt) {
      const versementDate = new Date(versement.createdAt).toLocaleDateString();
      const filterDate = new Date(filterValues.createdAt).toLocaleDateString();
      match = match && versementDate === filterDate;
    }
    return match;
  });

const handleApplyFilters = (filters) => {
setFilterValues(filters);
};
useEffect(() => {
  const fetchTransferBusiness = async () => {
    setLoading(true); // 🔥 IMPORTANT

    try {
      const res = await getTransactionByBusiness(developer?.id);
      setBusinessTransfer(res?.data || []);
    } catch (error) {
      console.error("Erreur :", error);
      setBusinessTransfer([]);
    } finally {
      setLoading(false); // 🔥 IMPORTANT
    }
  };

  if (developer?.id) {
    fetchTransferBusiness();
  }
}, [developer?.id]);
const countryFlags = {
  "221": "https://flagcdn.com/w40/sn.png",
  "225": "https://flagcdn.com/w40/ci.png", 
  "226": "https://flagcdn.com/w40/bf.png", 
  "229": "https://flagcdn.com/w40/bj.png", 
  "227": "https://flagcdn.com/w40/ne.png", 
  "223": "https://flagcdn.com/w40/ml.png",
  "224": "https://flagcdn.com/w40/gn.png", 
  "228": "https://flagcdn.com/w40/tg.png", 
  "237": "https://flagcdn.com/w40/cm.png",
  "243": "https://flagcdn.com/w40/cd.png", 
  "254": "https://flagcdn.com/w40/ke.png", 
  "234": "https://flagcdn.com/w40/ng.png",
  "233": "https://flagcdn.com/w40/gh.png", 
};
const getFlagFromPhone = (phoneNumber) => {
  if (!phoneNumber) return "🏳️";
  const digits = phoneNumber.replace(/\D/g, "");
  const matchedCode = Object.keys(countryFlags).find(code => digits.startsWith(code));
  return matchedCode ? countryFlags[matchedCode] : "🏳️";
};
const formatSenegalPhoneNumber = (number) => {
  if (!number) return "";
  const digits = number.replace(/\D/g, "");
  if (digits.length === 8) {
    return digits.replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, "$1 $2 $3 $4");
  }
  if (digits.startsWith("221") && digits.length === 11) {
    const local = digits.slice(3); 
    return local.replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, "$1 $2 $3 $4");
  }
  return number;
};
const renderStatusBadge = (status) => {
  let label = "Inconnu";
  let icon = "❓";
  const style = {
    backgroundColor: "#FFEFD5",
    color: "#000",
    padding: "1px 6px",
    borderRadius: "100px",
    fontWeight: 400,
    fontSize: "13px",
    fontStyle: "Medium",
    display: "inline-block"
  };
  if (status === "SUCCESS") {
    label = "Succés";
    icon = "✓";
    style.backgroundColor = "#EBFFEA";
    style.color = "#349C32";
  } else if (status === "REJECTED") {
    label = "Rejetée";
    icon = "❌";
    style.backgroundColor = "#FFF0F0";
    style.color = "#D41C1C";
  }
  else if (status === "PENDING" ) {
    label = "Encours";
     icon = "⌛";
    style.backgroundColor = "#f9ffeaff";
     style.color = "#f1c40f";
  }
  return <span style={style}>{icon} {label}</span>;
  };
  const columns = [
 {
  Header: "ID",
  accessor: "transactionReference",
  Cell: ({ value }) => {
    if (!value) return "-";
    return `${value.slice(0, 4)}****${value.slice(-4)}`;
  },
},
   {
    Header: "Compte",
    accessor: "paymentMethodName",
  },
   {
    Header: "Date",
    accessor: "createdAt",
    Cell: ({ value }) =>
      new Date(value).toLocaleDateString(),
  },
  {
    Header: "Montant",
    accessor: "amount",
    Cell: ({ row }) =>
      `${row.original.amount} ${row.original.currency}`,
  },
{
  Header: "N° Téléphone",
  accessor: "clientNumber",
  Cell: ({ row }) => {
    const {clientNumber} = row.original;
    const flag = getFlagFromPhone(clientNumber);
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {flag.startsWith("http") ? (
          <img src={flag} alt="flag" style={{ width: 20, height: 14 }} />
        ) : (
          <span>{flag}</span>
        )}
        <span>{formatSenegalPhoneNumber(clientNumber)}</span>
      </div>
    );
  },
  filterable: false,
},
  {
    Header: "Status",
    accessor: "status",
    Cell: ({ value }) => renderStatusBadge(value),
  },
      {
     Header: () => (
    <div style={{ textAlign: "right", width: "100%" }}>
      Action
    </div>
  ),
  accessor: "action",
      Cell: ({ row }) => {
        return (
           <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div  className="consulter"
           onClick={() => openModal("versement-detail", row.original)}>
             consulter
            </div>
          </div>
        );
      },
      filterable: false,
    },
  ];

  console.log("filteredVersement", transferBusiness);

    return (
         <Row className="w-100 m-0">
           <div className="mt-4 px-3" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <div className="header-actions  d-flex flex-wrap align-items-center gap-2 mb-3 w-100">
        <input
          type="text"
          placeholder="Recherche une transaction..."
          className="form-control search"
          style={{ maxWidth: '450px' }}
          onChange={(e) => setSearchTerm(e.target.value)}
          value={searchTerm}
        />
        <Button className="filtrer" onClick={() => openModal("versement-filtrer")} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <img src={filter} alt="Filtrer" style={{ width: "20px", height: "20px" }} />
          Filtrer
        </Button>
        <ExportTransaction transactions={filteredVersement} />
      </div>
    </div>
        <Col className="w- p-0">
        <Card className="h-100 w-100" style={{ border: "1px solid #E3E3E3" }}>
    <CardBody className="p-0 ">
        {loading ? (
     <div style={{ textAlign: "center", padding: "20px" }}>
    ⏳<Spin/>
  </div>
) : (
  <TableContainerMin
    columns={columns}
    data={filteredVersement || []}
    isGlobalFilter={false}
    customPageSize={10} 
    className="custom-header-css"
    divClass="table-responsive"
    tableClass="table w-100 mb-0 no-column-borders"
    theadClass="custom-thead"
    SearchPlaceholder="Recherche..."
    // HeaderTable={HeaderTable}
  />
)}
       
  {filteredVersement && filteredVersement.length === 0 && !loading && (
     <div
        style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px 0"
      }}
    >
   <div style={{ textAlign: "center", padding: "20px" }}>
    📭 Aucune transaction trouvé
  </div>
</div>
  )}
</CardBody>
</Card>
</Col>
{modalState.type === "versement-detail" && (
              <DetailVersementModal
                isOpen={modalState.type === "versement-detail"}
                toggle={() => openModal("versement-detail", modalState.data)}
                transaction={modalState.data}
              />
            )}
             {modalState.type === "versement-filtrer" && (
              <FiltrerVersementModal
                isOpen={modalState.type === "versement-filtrer"}
                toggle={() => openModal("versement-filtrer", modalState.data)}
                 onApply={handleApplyFilters}
              />
            )}
</Row>  
);
};
export default Versement;